"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// CORE
const React = __importStar(require("react"));
// MUI
const mui_1 = require("tss-react/mui");
const ArrowBack_1 = __importDefault(require("@mui/icons-material/ArrowBack"));
const Breadcrumbs_1 = __importDefault(require("@mui/material/Breadcrumbs"));
const Link_1 = __importDefault(require("@mui/material/Link"));
// COMPONENTS
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const QAmountField_1 = __importDefault(require("components/QAmountField"));
const RendersCount_1 = __importDefault(require("components/RendersCount"));
// LOCAL
const state_1 = require("../state");
const useStyles = (0, mui_1.makeStyles)()((theme) => ({
    crumbsContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 10,
    },
    crumb: {
        color: theme.palette.text.primary,
    },
    crumbColor: {
        color: theme.palette.text.secondary,
    },
    lastCrumbColor: {
        color: theme.palette.text.primary,
    },
    finalCrumbInfo: {
        borderBottom: `1px solid ${theme.palette.border.main}`,
        paddingBottom: 5,
        marginBottom: 16,
    },
}));
const Breadcrumbs = () => {
    const { classes } = useStyles();
    const { state, dispatch } = React.useContext(state_1.ReportsStateContext);
    const { breadcrumbs } = state;
    const backIconStyle = React.useMemo(() => breadcrumbs.length <= 1 ? { width: 0, padding: 0, opacity: 0 } : { padding: 2, marginRight: 4 }, [breadcrumbs.length]);
    const finalCrumb = breadcrumbs[breadcrumbs.length - 1];
    const handleCrumbClick = (crumbIndex) => (e) => {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        if (crumbIndex === breadcrumbs.length - 1) {
            return; // not going anywhere
        }
        dispatch({ type: 'update', payload: { breadcrumbs: breadcrumbs.slice(0, crumbIndex + 1) } });
    };
    return (<div>
      <RendersCount_1.default id="newReportsBreadcrumbs"/>
      <div className={classes.crumbsContainer}>
        <QIconButton_1.default onClick={handleCrumbClick(breadcrumbs.length - 2)} disabled={breadcrumbs.length === 1} style={backIconStyle}>
          <ArrowBack_1.default />
        </QIconButton_1.default>
        <Breadcrumbs_1.default maxItems={5}>
          {breadcrumbs.map((crumb, crumbIndex) => (<Link_1.default underline="hover" className={classes.crumb} onClick={handleCrumbClick(crumbIndex)} key={`crumb-${crumb}`}>
              <QTypography_1.default id={`reports-breadcrumb-${crumbIndex}`} className={crumbIndex === breadcrumbs.length - 1 ? classes.lastCrumbColor : classes.crumbColor} variant="subtitle2">
                {crumb.name}
              </QTypography_1.default>
            </Link_1.default>))}
        </Breadcrumbs_1.default>
      </div>
      {breadcrumbs.length > 1 &&
            <div className={classes.finalCrumbInfo}>
          <QTypography_1.default variant="body1">{finalCrumb.name}</QTypography_1.default>
          <QAmountField_1.default expectedSign="positive" styleProps={{ fontSize: 26 }} value={finalCrumb.total}/>
        </div>}
    </div>);
};
exports.default = Breadcrumbs;
